import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {
    static get APP_URL(): string {
        return environment.appUrl + 'user/';
    }

    static get LOGIN(): string {
        return AppUrl.APP_URL + 'login';
    }

    static get SELF(): string {
        return AppUrl.APP_URL + 'self';
    }

    static UPDATE_SELF(): string {
        return AppUrl.APP_URL + 'update-self';
    }

    static LOGOUT(): string {
        return AppUrl.APP_URL + 'logout';
    }

    static PRODUCT(): string {
        return AppUrl.APP_URL + 'product';
    }

    static STOCKIST_PRODUCT(id): string {
        return AppUrl.APP_URL + 'stockist-products/' + id;
    }

    static SESSION(): string {
        return AppUrl.APP_URL + 'session';
    }

    static GENRATE_ORDER_ID(): string {
        return AppUrl.APP_URL + 'generate-order-id';
    }


    static ORDER(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'user-product-order/' + id;
        } else {
            return AppUrl.APP_URL + 'user-product-order';
        }
    }


    static ORDER_ONLINE(id): string {
        return AppUrl.APP_URL + 'user-product-order-online/' + id;
    }

    static CART(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'cart/' + id;
        } else {
            return AppUrl.APP_URL + 'cart';
        }
    }

    static CLEAR_CART(): string {
        return AppUrl.APP_URL + 'clear-cart';
    }

    static USER_PRODUCT_ORDER(): string {
        return AppUrl.APP_URL + 'user-product-order';
    }

    static USER_PRODUCT_ORDER_COUNT(): string {
        return AppUrl.APP_URL + 'user-product-order-count';
    }

    static USER_PACKAGES_ORDER(): string {
        return AppUrl.APP_URL + 'package-order';
    }

    static USER_PACKAGES_ORDER_COUNT(): string {
        return AppUrl.APP_URL + 'package-order-count';
    }

    static USER_RECENT_PACKAGES_ORDER_COUNT(): string {
        return AppUrl.APP_URL + 'recent-package-order-count';
    }

    static MY_PRODUCT(): string {
        return AppUrl.APP_URL + 'stockist-product';
    }

    static PACKAGE(): string {
        return AppUrl.APP_URL + 'package';
    }

    static PACKAGE_ORDER(): string {
        return AppUrl.APP_URL + 'package-order';
    }

    static ONLINE_PACKAGE_ORDER(): string {
        return AppUrl.APP_URL + 'package-order-online';
    }

    static STOCKIST(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'stockist/' + id;
        } else {
            return AppUrl.APP_URL + 'stockist';
        }
    }

    static STOCKIST_BY_ID(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'stockist-by-id/' + id;
        }
    }

    static STOCKIST_BY_UNIQUE_ID(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'stockist-by-uniqueId/' + id;
        }
    }

    static USER(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'user/' + id;
        } else {
            return AppUrl.APP_URL + 'user';
        }
    }

    static USER_PAN(): string {
        return AppUrl.APP_URL + 'user-pan';
    }

    static USER_AADHAR(): string {
        return AppUrl.APP_URL + 'user-aadhar';
    }

    static USER_BANK(): string {
        return AppUrl.APP_URL + 'user-bank';
    }

    static USER_NOMINEE(): string {
        return AppUrl.APP_URL + 'user-nominee';
    }

    static MATCHING_TREE(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'matching-tree/' + id;
        } else {
            return AppUrl.APP_URL + 'matching-tree';
        }
    }

    static DOWNLINE_MEMBER(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'downline-member/' + id;
        }
    }

    static ADD_MONEY_TO_WALLET(unique_id): string {
        return AppUrl.APP_URL + 'add-money-wallet/' + unique_id;
    }


    static MY_MEMBERS(): string {
        return AppUrl.APP_URL + 'my-members';
    }

    static MY_MEMBERS_COUNT_SPONSOR(): string {
        return AppUrl.APP_URL + 'my-members-count-direct-sponsor';
    }

    static SELF_REPURCHASE_BASIC_VALUE_COUNT(): string {
        return AppUrl.APP_URL + 'self-repurchase-basic-value-count';
    }

    static SELF_REPURCHASE_TEAM_BASIC_VALUE_COUNT(): string {
        return AppUrl.APP_URL + 'self-repurchase-team-basic-value-count';
    }

    static FILE_UPLOAD(): string {
        return AppUrl.APP_URL + 'file-upload';
    }

    static STATES(): string {
        return AppUrl.APP_URL + 'states';
    }

    static ADDRESS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'address/' + id;
        } else {
            return AppUrl.APP_URL + 'address';
        }
    }

    static PROFILE_IMAGE(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'profile-image/' + id;
        } else {
            return AppUrl.APP_URL + 'profile-image';
        }
    }

    static ADDRESS_DETAILS(id): string {
        return AppUrl.APP_URL + 'update-user-address/' + id;
    }

    static SELF_PROFILE_PASSWORD(): string {
        return AppUrl.APP_URL + 'update-user-password';
    }

    static VERIFY_OTP_SELF_PROFILE_PASSWORD(): string {
        return AppUrl.APP_URL + 'verify-otp-update-user-password';
    }

    static USER_WITHDRAW_REQUEST(): string {
        return AppUrl.APP_URL + 'withdraw-request';
    }

    static SUPPORT(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'support/' + id;
        } else {
            return AppUrl.APP_URL + 'support';
        }
    }

    static ANNOUNCEMENT(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'announcement/' + id;
        } else {
            return AppUrl.APP_URL + 'announcement';
        }
    }

    static PAIRING_BONUS(): string {
        return AppUrl.APP_URL + 'user-package-value-transaction';
    }

    static PAIRING_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'user-package-value-transaction-count';
    }

    static MONTHLY_PAIRING_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'user-monthly-package-value-transaction-count';
    }

    static SELF_REPURCHASE_BONUS(): string {
        return AppUrl.APP_URL + 'self-repurchase-bonus';
    }

    static SELF_REPURCHASE_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'self-repurchase-bonus-count';
    }

    static SELF_REPURCHASE_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'self-repurchase-today-bonus-count';
    }

    static PERFORMANCE_BONUS(): string {
        return AppUrl.APP_URL + 'performance-bonus';
    }

    static PERFORMANCE_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'performance-bonus-count';
    }


    static PERFORMANCE_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'performance-today-bonus-count';
    }

    static DIRECTOR_BONUS(): string {
        return AppUrl.APP_URL + 'director-bonus';
    }

    static DIRECTOR_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'director-bonus-count';
    }

    static DIRECTOR_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'director-today-bonus-count';
    }

    static LEADERSHIP_BONUS(): string {
        return AppUrl.APP_URL + 'leadership-bonus';
    }

    static LEADERSHIP_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'leadership-bonus-count';
    }

    static LEADERSHIP_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'leadership-today-bonus-count';
    }

    static HOUSE_FUND_BONUS(): string {
        return AppUrl.APP_URL + 'house-fund-bonus';
    }

    static HOUSE_FUND_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'house-fund-bonus-count';
    }


    static HOUSE_FUND_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'house-fund-today-bonus-count';
    }

    static CAR_FUND_BONUS(): string {
        return AppUrl.APP_URL + 'car-fund-bonus';
    }

    static CAR_FUND_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'car-fund-bonus-count';
    }

    static CAR_FUND_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'car-fund-today-bonus-count';
    }

    static TOUR_FUND_BONUS(): string {
        return AppUrl.APP_URL + 'tour-fund-bonus';
    }

    static TOUR_FUND_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'tour-fund-bonus-count';
    }


    static TOUR_FUND_TODAY_BONUS_COUNT(): string {
        return AppUrl.APP_URL + 'tour-fund-today-bonus-count';
    }

    static USER_TRANSACTION(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'user-transaction/' + id;
        } else {
            return AppUrl.APP_URL + 'user-transaction';
        }
    }
}
